import { LayoutComponent } from './layouts/layout/layout.component';
import { VexRoutes } from '@vex/interfaces/vex-route.interface';
import { authGuard } from './core/auth/auth.guard';
import { NotFoundComponent } from './pages/pages/auth/not-found/not-found.component';


export const appRoutes: VexRoutes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },

  // ─────────────────────────────────────────────
  // RUTAS PÚBLICAS — Auth
  // ─────────────────────────────────────────────
  {
    path: 'zia',
    loadComponent: () => import('./pages/public/zia-chat/zia-chat.component').then(m => m.ZiaChatComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/pages/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/pages/auth/register/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/pages/auth/forgot-pass/forgot-pass.component').then(m => m.ForgotPassComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/pages/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: 'callbacks/google',
    loadComponent: () => import('./pages/pages/auth/oauth-callback/oauth-callback.component').then(m => m.OauthCallbackComponent)
  },
  {
    path: 'auth/microsoft/callback',
    loadComponent: () => import('./pages/pages/auth/microsoft-callback/microsoft-callback.component').then(m => m.MicrosoftCallbackComponent)
  },

  // ─────────────────────────────────────────────
  // RUTAS PRIVADAS — dentro del layout
  // ─────────────────────────────────────────────
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: 'cic-home',
        children: [
          { path: '', redirectTo: 'home', pathMatch: 'full' },
          {
            path: 'home',
            loadComponent: () => import('./pages/cic-home/home/home.component').then(m => m.HomeComponent),
            data: { toolbarShadowEnabled: true, id_modulo: 1, id_vista: 1 }
          }
        ]
      },
      {
        path: 'solutions',
        children: [
          {
            path: 'natal_ia',
            loadComponent: () => import('./pages/ia/assistants/natal-ia-chat/natal-ia-chat.component').then(m => m.NatalIaChatComponent),
            data: { id_modulo: 2, id_vista: 2 }
          },
          {
            path: 'pos',
            loadComponent: () => import('./pages/solutions/pos/pos.component').then(m => m.PosComponent),
            data: { id_modulo: 2, id_vista: 2 }
          }
        ]
      },
      {
        path: 'ia',
        children: [
          {
            path: 'assistants',
            loadComponent: () => import('./pages/ia/assistants/assistants-grid/assistants-grid.component').then(m => m.AssistantsGridComponent),
            data: { id_modulo: 3, id_vista: 4 }
          },
          {
            path: 'chat',
            loadChildren: () => import('./pages/ia/assistants/chat/chat.routes').then(m => m.chatRoutes),
            data: { id_modulo: 3, id_vista: 4 }
          }
        ]
      },
      {
        path: 'agency',
        children: [
          {
            path: 'administracion-tickets',
            loadComponent: () => import('./pages/agency/ticket-administration/ticket-administration.component').then(m => m.TicketAdministrationComponent),
            data: { toolbarShadowEnabled: true, id_modulo: 4, id_vista: 6 }
          },
          { path: 'gaming-licenses',
            loadChildren: () => import('./pages/agency/gaming-licenses/gaming-licenses.routes'),
            data: { id_modulo: 4, id_vista: 5 }
          }
        ]
      },
      {
        path: 'options',
        children: [
          {
            path: 'config',
            loadComponent: () => import('./pages/cic-home/home/home.component').then(m => m.HomeComponent)
          },
          {
            path: 'soporte',
            loadChildren: () => import('./pages/options/support/support.routes'),
            data: {id_modulo: 5, id_vista: 7},
          },
          { path: 'user',
            loadChildren: () => import('./pages/options/admin/admin.routes'),
            data: { id_modulo: 5, id_vista: 8 },
          },
        ]
      },
      { path: 'options-user',
        children: [
          { path: 'profile',
            loadChildren: () => import('./pages/options-user/profile/profile.routes').then(m => m.default),
            data: { id_modulo: 7, id_vista: 22 },
          },
          { path: 'messages',
            loadComponent: () => import('./pages/options-user/messages/messages.component').then((m) => m.MessagesComponent)
          },
          { path: '**', component: NotFoundComponent
          }
        ]
      },
      {
        path: 'consultas',
        children: [
          {
            path: 'aws',
            loadComponent: () => import('./pages/consultas/aws/aws.component').then(m => m.AwsComponent),
            data: { id_modulo: 6, id_vista: 9 }
          },
          {
            path: 'azure',
            loadComponent: () => import('./pages/consultas/azure/azure.component').then(m => m.AzureComponent),
            data: { id_modulo: 6, id_vista: 10 }
          },
          {
            path: 'productos',
            loadComponent: () => import('./pages/products/products.component').then(m => m.ProductsComponent),
            data: { id_modulo: 6, id_vista: 12 }
          }
        ]
      }
    ]
  },
  // ─────────────────────────────────────────────
  // NOT FOUND
  // ─────────────────────────────────────────────
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: 'not-found' }
];
